import React, { useState } from 'react'; // Import useState for managing component state
import '../css/NavigationBar.css'; // Importing CSS for styling the About Us page
import { IoMenu } from "react-icons/io5"; // Importing a menu icon from react-icons
import { Link } from "react-router-dom";

const Navigationbar = () => {
    // State to handle the visibility of the menu items
    const [isMenuVisible, setIsMenuVisible] = useState(false);

    // Function to toggle menu visibility
    const toggleMenu = () => {
        setIsMenuVisible(!isMenuVisible); // Toggle the state from true to false and vice versa
    };

    return (
        <div>
            <div className="parentnavbar"> {/* Main container for the navbar */}
                <div className='logo'>
                    <img className='logoimg' src='/images/ft_logo.png' alt='logo'></img>
                </div>
                <div className='bar'>
                        <Link to="/login" className='login'>Login</Link>
                   
                    <Link  to="/">Home</Link>                    
                    <Link  to="/services">Services</Link>
                    <Link  to="/aboutus">About Us</Link>
                    <Link  to="/contactus">Contact Us</Link>
                    
                </div>
            </div>
            <div className='mobileparentnavbar'>
                <div className='mobilebar'>
                    <IoMenu onClick={toggleMenu} /> {/* Menu icon with click handler */}
                    {/* Conditional rendering of menu items based on isMenuVisible */}
                    {isMenuVisible && (
                        <div className='menuitems'>
                            <Link  to="/login">Login</Link>  
                           <Link  to="/">Home</Link>                    
                    <Link  to="/services">Services</Link>
                    <Link  to="/aboutus">About Us</Link>
                    <Link  to="/contactus">Contact Us</Link>
                    </div>
                    )}
                </div>
                <div className='mobilelogo'>
                    <img className='logoimg' src='/images/ft_logo.png' alt='logo'></img>
                </div>
            </div>
        </div>
    );
};

export default Navigationbar; // Exporting the Navbar component for use in other parts of the application
